import {
  TableCell,
  Table,
  TableRow,
  Grid,
  Button
} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import styled from "styled-components";

export const StyledTable = styled(Table)`
  && {
    width: 50%;
    margin-top: 20px;
    overflow: auto;
  }
`;

export const StyledHeaderCell = styled(TableCell)`
  && {
    font-weight: bold;
    font-size: 17px;
    color: black;
    background-color: #fff;
  }
  &&:last-child {
    width: 50%;
  }
`;
export const StyledTableCell = styled(TableCell)`
  && {
    font-size: 17px;
    color: black;
    white-space: nowrap;
  }
  &&:last-child {
    width: 50%;
  }
`;

export const StyledTableRow = styled(TableRow)` && {
    /* Work Sans / 12 Semibold CAPS */
    font-family: Work Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;


    /* Text / Dark Gray */
    color: #5F6368;

    height: 24px;
    padding: 0.5em;
  }
`;

export const StyledTableDataRow = styled(TableRow)` && {
  /* Work Sans / 14 Medium */
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 130%;
  
  
  /* Text / Black */
  color: #000000;
  }
`;
export const StyledGrid = styled(Grid)`&& {
  margin-top: 20px;
}
`;

export const PrimaryButton = styled(Button)`
  && {
    background: #2196f3;
    color: white;
    font-size: 17px;
    padding: 0px 8px;
    height: auto;
  }
  
  &&:hover {
    background:#80c0f2;
  }
`;

export const YieldResults = styled(Paper)`
  && {
    padding: 20px;
    background: #00c61e;
  }
`;
